import { observer } from 'mobx-react'
import React, { FC } from 'react'

import { BookingStatus } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { CheckboxBasedFilter } from '@avantstay/backoffice-core'

import { FilterRenderingComponentProps } from '@new/__global/components/FiltersFramework'
import { bookingReservationStatusOptions } from '@new/domains/bookingsTapeChart/BookingsTapeChart.constants'

const _ReservationStatusFilter: FC<FilterRenderingComponentProps<BookingStatus[]>> = ({
  label,
  activeValue,
  ...restProps
}) => (
  <CheckboxBasedFilter
    title={label}
    options={bookingReservationStatusOptions}
    initialValue={activeValue}
    {...restProps}
  />
)

export const ReservationStatusFilter = observer(_ReservationStatusFilter)
